module.exports = __webpack_public_path__ + "img/lesson_03.e72e5821.jpg";